<!-- 个人中心 -->
<template>
  <div class="profile">
    <div class="edit-box" v-show="editShow">
      <div class="mask"></div>
      <div class="wrap">
        <div class="title">修改密码</div>
        <el-form
          ref="form"
          :model="editParams"
          :rules="editRules"
          label-width="100px"
        >
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="editParams.password"
              type="password"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPwd">
            <el-input
              v-model="editParams.confirmPwd"
              type="password"
              placeholder="请确认新密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="menus">
          <el-button @click="cancelEdit">关闭</el-button>
          <el-button type="primary" @click="confirmEdit">确认更改</el-button>
        </div>
      </div>
    </div>
    <div class="infoes">
      <el-descriptions title="欢迎您" :column="2" border>
        <el-descriptions-item label="注册日期：" :span="2">{{
          userInfo.createTime | handleTime
        }}</el-descriptions-item>
        <el-descriptions-item label="真实姓名：">{{
          userInfo.trainUserName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="性别：">{{
          userInfo.gender || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="身份证号：">{{
          userInfo.idNum || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="手机号：">{{
          userInfo.phoneNo || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="职称：">{{
          userInfo.position || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="学历：">{{
          userInfo.education || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="工种：" :span="2">{{
          userInfo.workTypeName || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="收货地址：" :span="2">{{
          userInfo.paperAddress || "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="寸照：">
          <img
            class="post"
            :src="URL + userInfo.imgUrl"
            v-if="userInfo.imgUrl"
          />
          <span v-else>--</span>
        </el-descriptions-item>
      </el-descriptions>
      <div class="menus">
        <el-button type="primary" @click="startEditPwd">修改密码</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "../../util/config";
export default {
  data() {
    const confirmPwdValid = (r, v, cb) => {
      if (this.editParams.password != v) {
        cb("密码不一致!");
        return;
      }
      cb();
    };
    return {
      URL,
      userInfo: {},
      editShow: false,
      editParams: {
        password: "",
        confirmPwd: "",
        code: "",
      },
      editRules: {
        password: { required: true, message: "请输入密码", trigger: "blur" },
        confirmPwd: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: confirmPwdValid, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    let infoJson = localStorage.getItem("userInfo");
    if (infoJson) {
      this.userInfo = JSON.parse(infoJson);
    }
  },
  methods: {
    startEditPwd() {
      this.editShow = true;
    },
    cancelEdit() {
      this.editShow = false;
      Object.assign(this.$data.editParams, this.$options.data().editParams);
    },
    confirmEdit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await this.$api.updatePwd(this.editParams);
          if (res.code == 0) {
            this.$notify.success({
              title: "修改成功",
              message: "即将前往登录",
            });
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            this.cancelEdit();
            setTimeout(() => {
              this.$router.push("/login");
            }, 2000);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-box {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2005;

  .mask {
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.7);
  }
  .wrap {
    width: 500px;
    background-color: #fff;
    padding: 30px;
    box-sizing: border-box;
    border-radius: 5px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .title {
      font-size: 18px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .menus {
      display: flex;
      justify-content: center;
    }
  }
}
.menus {
  display: flex;
  margin-top: 20px;
}
.post {
  width: 150px;
}
</style>
